<script lang="ts">
    import type { Newsletter } from '../../api/news.ts';
    import { push } from 'svelte-spa-router';

    export let newsletter: Newsletter;
    export let image: string;

    function goToNewsletter() {
        push(`/Newsletters/${newsletter.id}?isInformational=${newsletter.isInformationalBroadcast}`);
    }
</script>

<div
        role="button"
        tabindex="0"
        on:click={goToNewsletter}
        on:keydown={(e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      goToNewsletter();
    }
  }}
        class="block w-full box-border cursor-pointer transition-transform duration-200 ease-in-out hover:scale-[1.01]"
>
    <div
            class="flex flex-col md:flex-row border border-gray-300 bg-white overflow-hidden h-auto md:h-[150px] rounded-lg"
            data-testid={`news-post-${newsletter.id}`}
    >
        <img
                src={image}
                alt={newsletter.name}
                class="w-full md:w-2/5 h-[140px] md:h-auto object-cover"
                data-testid="image"
        />

        <div class="w-full md:w-3/5 p-4 md:p-6 flex flex-col gap-2" data-testid="content">
            <p class="text-sm text-gray-500" data-testid="date">
                {newsletter.getDisplayedDate()}
            </p>
            <h3 class="text-base md:text-lg font-semibold text-black line-clamp-2" data-testid="headline">
                {newsletter.name}
            </h3>
        </div>
    </div>
</div>
